module.exports = __webpack_public_path__ + "img/minus.5b7adfbe.svg";